export enum AddressType {
    AddressTypeDefault,
    AddressTypeShipping,
    AddressTypeBilling ,
}

